import { useCallback } from 'react';

import { Heading, Icon, Paragraph, TextButton, Toast, Upsell, useToast } from '@zillow/constellation-10';
import { IconMegaphoneFilled } from '@zillow/constellation-icons';

import { WAITLIST_NOTIFICATION_BODY, ZILLOW_LEASES } from '../../constants/stringConstants';
import { useAddToWaitlistMutation, useDeclineToWaitlistMutation, usePropertyInfoQuery } from '../../utils/queries';
import { Property } from '../../models';
import { useLeasingUrlParams } from '../../hooks/useLeasingUrlParams';

function RegionWaitlistUpsell(): JSX.Element {
  const { propertyId } = useLeasingUrlParams();
  const { data: propertyData } = usePropertyInfoQuery(propertyId);
  const property = propertyData ? new Property({ ...propertyData, propertyId }) : null;
  const region = property?.getStateName() || '';

  const { enqueueToast } = useToast();
  const { mutateAsync: addToWaitlist } = useAddToWaitlistMutation();
  const { mutateAsync: declineToWaitlist } = useDeclineToWaitlistMutation();

  const onGetNotifiedToast = useCallback(() => {
    enqueueToast(<Toast tone="success">{WAITLIST_NOTIFICATION_BODY}</Toast>);
  }, [enqueueToast]);

  async function onClickGetNotified() {
    await addToWaitlist({ postData: { propertyId } });
    onGetNotifiedToast();
  }

  function onClickNoThanks() {
    declineToWaitlist({ postData: { propertyId } });
  }

  return (
    <Upsell
      header={<Heading level={2}>{`${ZILLOW_LEASES} in ${region} coming soon!`}</Heading>}
      body={<Paragraph>Build free customized leases specific for your area.</Paragraph>}
      action={
        <TextButton tone="brand" onClick={onClickGetNotified}>
          Get notified
        </TextButton>
      }
      tone="neutral"
      closeable
      onOpenChange={(open) => {
        if (!open) {
          onClickNoThanks();
        }
      }}
      media={
        <Icon size="lg">
          <IconMegaphoneFilled />
        </Icon>
      }
      elevated={false}
    />
  );
}

export default RegionWaitlistUpsell;
